import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldInputRow, FieldRow } from "namirasoft-field";
import { BaseVariableSchema } from "namirasoft-schema";
import { NSBox, NSBoxSchemaVariable, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface FieldEditPageProps extends NSARouterMakerResult, FieldProps
{
	isEdit: boolean
}

interface FieldEditPageState { }

export default class FieldEditPage extends Component<FieldEditPageProps, FieldEditPageState>
{
	NSBoxSchemaVariable_Type = createRef<NSBoxSchemaVariable>();
	NSBoxTexArea_Description = createRef<NSBoxTextArea>();

	constructor(props: FieldEditPageProps)
	{
		super(props);
		this.state = {};
	}

	override render()
	{
		return (
			<FieldLayout<FieldRow, FieldInputRow>
				{...this.props}
				action={{
					description: this.props.isEdit ? "This section allows you to update the details of an existing field." : "This section allows you to add a new field by entering its details and settings."
				}}
				pages={{
					entity: FieldEntities.field(this.props),
					edit: {
						...this.props,
						ui: {
							tab_page_edit: {
								editor: {
									getInputRow: () =>
									{
										let type = this.NSBoxSchemaVariable_Type.current?.getValue() as BaseVariableSchema;
										let name = type?.name ?? "";
										let description = this.NSBoxTexArea_Description.current?.getValue() ?? "";

										return {
											workspace_id: "",
											name,
											type,
											description,
											field_category: [],
											field_field: [],
											field_tag: []
										};
									},
									setRow: (row) =>
									{
										this.NSBoxSchemaVariable_Type.current?.setValue(row.type);
										this.NSBoxTexArea_Description.current?.setValue(row.description ?? "");
									}
								}
							}
						}
					}
				}}
			>
				<NSColumn>
					<NSBoxSchemaVariable
						ref={this.NSBoxSchemaVariable_Type}
						name="type"
						required
						title="Type"
						style={{ width: NSBox.width.double }}
						info={{ link: "https://namirasoft.com/field/console-guide/field/#field-type" }}
					></NSBoxSchemaVariable>
					<NSBoxTextArea
						ref={this.NSBoxTexArea_Description}
						title="Description"
						required={false}
						style={{ width: NSBox.width.double }}
						info={{ link: "https://namirasoft.com/field/console-guide/field/#field-description" }}
					/>
				</NSColumn >
			</FieldLayout>
		);
	}
}